import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Servers from "@/pages/Servers";
import Hotels from "@/pages/Hotels";
import HotelDetail from "@/pages/HotelDetail";
import Deploy from "@/pages/Deploy";
import Onboarding from "@/pages/Onboarding";
import Admins from "@/pages/Admins";
import DsiTeam from "@/pages/DsiTeam";
import Logs from "@/pages/Logs";
import Mt3cx from "@/pages/Mt3cx";
import Guide3cx from "@/pages/Guide3cx";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null)
    return (
      <div className="flex h-screen items-center justify-center bg-zinc-50">
        <div className="font-mono text-sm text-zinc-400">Chargement…</div>
      </div>
    );
  if (user === false) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function SuperOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "super_admin") return <Navigate to="/" replace />;
  return children;
}

function HotelAdminOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "hotel_admin" && user.role !== "super_admin") return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <AppLayout />
          </Protected>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route
          path="/servers"
          element={
            <SuperOnly>
              <Servers />
            </SuperOnly>
          }
        />
        <Route path="/hotels" element={<Hotels />} />
        <Route
          path="/guide"
          element={
            <SuperOnly>
              <Guide3cx />
            </SuperOnly>
          }
        />
        <Route path="/hotels/:id" element={<HotelDetail />} />
        <Route
          path="/team"
          element={
            <HotelAdminOnly>
              <DsiTeam />
            </HotelAdminOnly>
          }
        />
        <Route
          path="/onboarding"
          element={
            <SuperOnly>
              <Onboarding />
            </SuperOnly>
          }
        />
        <Route
          path="/deploy"
          element={
            <SuperOnly>
              <Deploy />
            </SuperOnly>
          }
        />
        <Route
          path="/admins"
          element={
            <SuperOnly>
              <Admins />
            </SuperOnly>
          }
        />
        <Route
          path="/logs"
          element={
            <SuperOnly>
              <Logs />
            </SuperOnly>
          }
        />
        <Route
          path="/mt-3cx"
          element={
            <SuperOnly>
              <Mt3cx />
            </SuperOnly>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
